import React from 'react'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import ReportsContainer from '@/app/module/reports/components/reports.container'
import { OrgReportFunction } from '@/app/module/reports/types'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps & {
    params: {
      reportType?: string
    }
    path: string
  }
}

const Reports: React.FC<Props> = ({ match }) => {
  const { reportType } = match.params
  const isCreateMode = match.path.endsWith('/create')

  const type = React.useMemo(() => {
    if (
      !reportType ||
      ![
        OrgReportFunction.Spend,
        OrgReportFunction.Deliverability,
        OrgReportFunction.Campaign,
        OrgReportFunction.Recordings,
      ].includes(reportType as OrgReportFunction)
    ) {
      return OrgReportFunction.Campaign
    }

    return reportType as OrgReportFunction
  }, [reportType])

  const title = React.useMemo(() => {
    switch (type) {
      case OrgReportFunction.Spend:
        return 'Reports - Spend Reports - engageSPARK'
      case OrgReportFunction.Deliverability:
        return 'Reports - Deliverability Reports - engageSPARK'
      case OrgReportFunction.Campaign:
        return 'Reports - Campaign Reports - engageSPARK'
      case OrgReportFunction.Recordings:
        return 'Reports - Call Recordings - engageSPARK'
      default:
        return 'Reports - engageSPARK'
    }
  }, [type])

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title={title}>
        <AuthHeader currentPage={PAGE.REPORTS.INDEX} />
        <TotpGuard>
          <ReportsContainer reportType={type} isCreateMode={isCreateMode} />
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}

export default Reports
